export const zy580Routes = [
    {
      path: "/zy580",
      name: "zy580",
      mata: {
        KeepAlive: true
      },
      children: [
        {
          path: "zysys/channelManagement",
          name: "zysys_channelManagement" ,
          component: () => import('@/view/business/zy580/zysys/channelManagement.vue'),
          meta: {
            KeepAlive: true,
            hasNav: true
          }
        },
        {
          path: "zysys/memberManagement",
          name: "memberManagement" ,
          component: () => import('@/view/business/zy580/zysys/memberManagement.vue'),
          meta: {
            KeepAlive: true,
            hasNav: true
          }
        },
      ]
    }
  ];